import { IconX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Modal, Spinner } from 'react-bootstrap';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { getApi, postApi } from '../../../api/call.api';
import { uploadImage } from '../../../api/api.global';
import { urlApi } from '../../../api/url.api';
import { toast } from 'sonner';
import _debounce from 'lodash/debounce';

const AddInfluencerModal = ({ buttonComponent, callback, agentData, callbackClose }) => {
    const [showModal, setShowModal] = useState(false);
    const [file, setFile] = useState(null);
    const [agentList, setAgentList] = useState([]);
    const [loadingState, setLoadingState] = useState(false);
    const [selectedAgent, setSelectedAgent] = useState(agentData || null);

    const handleClose = () => { setShowModal(false); callbackClose?.current?.click() };
    const handleShow = () => { setShowModal(true) };

    function fileOnChange(event) {
        let file = event.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 5;
        if (file && file.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 5MB.');
            setFile(null);
            event.target.value = null;
        } else {
            setFile(file);
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                document.getElementById('pic-preview').src = reader.result;
            }
        }
    }

    const searchAgent = async (e) => {
        if (e.target.value.length >= 3) {
            setLoadingState(true);
            let resp = await getApi(`${urlApi.searchAgent}?search=${e.target.value}`);
            setLoadingState(false);
            if (resp?.responseCode === 200) {
                setAgentList(resp.data);
            } else {
                setAgentList([]);
            }
        } else {
            toast.warning("Type minimum of 3 letters!")
        }
    }

    function onAgentSelect(agentData) {
        setSelectedAgent(agentData);
        setAgentList(null)
        document.getElementById('agentName').value = agentData.name;
    }

    async function add() {
        loadingShow();
        let localData = {
            "name": document.getElementById('name').value.trim(),
            "channelName": document.getElementById('channelName').value.trim(),
            "email": document.getElementById('email').value.trim(),
            "phone": document.getElementById('phone').value.trim(),
            "channelLink": document.getElementById('channelLink').value?.trim(),
            "address": document.getElementById('address').value,
            "note": document.getElementById('note').value,
            "genre": document.getElementById('genre').value.trim(),
        }

        let postData = {
            agentId: selectedAgent?._id,
            channelName: localData.channelName,
            channelLink: localData.channelLink,
        }

        if (localData?.email) {
            postData.email = localData?.email
        }

        if (localData?.phone) {
            postData.phone = localData?.phone
        }

        if (localData?.genre) {
            postData.genre = localData?.genre
        }

        if (localData?.name) {
            postData.name = localData?.name
        }

        if (localData?.address) {
            postData.address = localData?.address
        }

        if (localData?.note) {
            postData.note = localData?.note
        }

        if (file) {
            postData.channelLogo = await uploadImage(file, "advy-influencer-profile-pic")
        }

        let resp = await postApi(postData, urlApi.addInfluencer);
        loadingHide();
        if (resp.responseCode === 200) {
            callback?.();
            callbackClose?.current?.click()
            toast.success(resp.message);
            handleClose();
        } else {
            toast.error(resp.message);
        }
    }

    return (
        <>
            <div className='max-w-max' onClick={handleShow} >{buttonComponent}</div>

            <Modal show={showModal} onHide={handleClose} size='xl' backdrop="static">
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Add Influencer</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                        <div className="col-span-1">
                            <label htmlFor="channelName" className='text-sm font-semibold mb-1'>Channel Name *</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='channelName' />
                        </div>
                        <div className="col-span-1">
                            <label htmlFor="channelLink" className='text-sm font-semibold mb-1'>Channel Link*</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='channelLink' />
                        </div>
                        <div className="">
                            <label htmlFor="admin-profile-file" className='text-sm font-semibold mb-1'>Channel Logo (Max 5Mb)</label>
                            <input type="file" name="" id="admin-profile-file" onChange={(e) => fileOnChange(e)} className='w-full px-3 py-2 rounded-md border-2 text-sm' accept="image/png, image/gif, image/jpeg" />
                        </div>
                        <img src="" alt="" id='pic-preview' className='max-h-[200px] max-w-full object-contain rounded-md mx-auto mt-4' />
                        <div className="col-span-1">
                            <label htmlFor="genre" className='text-sm font-semibold mb-1'>Category/Genre*</label>
                            <select name="" id="genre" defaultValue={""} className='w-full px-3 py-2 rounded-md border-2 text-sm'>
                                <option value="" disabled>Category/Genre</option>
                                <option value="Fashion">Fashion</option>
                                <option value="Beauty">Beauty</option>
                                <option value="Fitness">Fitness</option>
                                <option value="Gaming">Gaming</option>
                                <option value="Tech">Tech</option>
                                <option value="Travel">Travel</option>
                                <option value="Food">Food</option>
                                <option value="Lifestyle">Lifestyle</option>
                                <option value="Business">Business</option>
                                <option value="Finance">Finance</option>
                                <option value="Education">Education</option>
                                <option value="Motivation">Motivation</option>
                                <option value="Entertainment">Entertainment</option>
                            </select>
                        </div>
                        <div className="col-span-1">
                            <label htmlFor="name" className='text-sm font-semibold mb-1'>Name</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='name' />
                        </div>
                        <div className="col-span-1">
                            <label htmlFor="phone" className='text-sm font-semibold mb-1'>Mobile</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' maxLength={10} id='phone' />
                        </div>
                        <div className="col-span-1">
                            <label htmlFor="email" className='text-sm font-semibold mb-1'>Email</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='email' />
                        </div>
                        <div className="col-span-1">
                            <label htmlFor="address" className='text-sm font-semibold mb-1'>Address</label>
                            <textarea type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='address' ></textarea>
                        </div>
                        <div className="col-span-1">
                            <label htmlFor="note" className='text-sm font-semibold mb-1'>Note</label>
                            <textarea type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='note' maxLength={255} ></textarea>
                        </div>
                    </div>

                    <div>
                        <label htmlFor="name" className='text-sm font-semibold mb-1'>Select Agent</label>
                        <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='Agent Name / Mobile / Email' id='agentName' disabled={agentData?._id} onChange={_debounce((e) => searchAgent(e), 600)} defaultValue={agentData?.name || ""} />
                    </div>
                    <div className="max-h-80 overflow-y-auto">
                        {
                            loadingState ? <div className='mt-2 flex justify-center w-full'> <Spinner /></div> : (agentList?.length > 0 &&
                                agentList?.map((item) => (
                                    <div key={item?._id} className='cursor-pointer hover:bg-gray-200 px-3 py-2 rounded-md text-sm flex items-center flex-wrap gap-2' onClick={() => onAgentSelect(item)}>
                                        <img src={item?.profilePic} alt="" className='h-7' />
                                        {item?.name} - {item?.phone} - {item?.email}
                                    </div>
                                )))
                        }
                    </div>

                    <hr className='my-2' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => add()}>Create</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddInfluencerModal